'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchLocationAwarePurchaseMotionData = exports.fetchPurchaseMotionData = undefined;

var _apiClient = require('hub-http/clients/apiClient');

var _apiClient2 = _interopRequireDefault(_apiClient);

var _memoize = require('../utilities/memoize');

var _memoize2 = _interopRequireDefault(_memoize);

var _q = require('q');

var _q2 = _interopRequireDefault(_q);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var fetchPurchaseMotionData = exports.fetchPurchaseMotionData = (0, _memoize2.default)(function (merchandiseIds) {
  return _apiClient2.default.post('/self-service/v2/purchase-motions', {
    data: {
      merchandiseIds: merchandiseIds
    }
  });
});

var fetchLocationAwarePurchaseMotionData = exports.fetchLocationAwarePurchaseMotionData = (0, _memoize2.default)(function (_ref) {
  var merchandiseIds = _ref.merchandiseIds,
      locations = _ref.locations,
      apiGetter = _ref.apiGetter;

  if (!apiGetter) {
    return _apiClient2.default.get('/self-service/v2/purchase-motions', {
      query: {
        merchandiseIds: merchandiseIds,
        location: locations
      }
    });
  }
  return new _q2.default.Promise(function (resolve, reject) {
    apiGetter.whenFinished(function (result) {
      resolve(result);
      window.quickFetch.removeEarlyRequest('purchase-motions');
    });
    apiGetter.onError(function (err) {
      reject(err);
      window.quickFetch.removeEarlyRequest('purchase-motions');
    });
  });
});


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/self-service-api/static-1.837/js/core/api/purchaseMotionApi.js
// module id = 473
// module chunks = 3 4 5